import { jsx } from 'react/jsx-runtime';
import { useState, useRef, useEffect } from 'react';
import { s as styleInject } from '../../../../style-inject.es-1f59c1d0.js';
import { c as classNames } from '../../../../index-6ea95111.js';

var css_248z = ".Collapsible-module_collapsible__2wWKs {\n  transition: max-height 0.3s ease-in-out;\n  overflow-y: clip;\n}";
var styles = {"collapsible":"Collapsible-module_collapsible__2wWKs"};
styleInject(css_248z);

var Collapsible = function (_a) {
    var _b;
    var children = _a.children, isExpanded = _a.isExpanded;
    var _c = useState(), height = _c[0], setHeight = _c[1];
    var observerRef = useRef(null);
    var containerRef = useRef(null);
    useEffect(function () {
        if (!observerRef.current) {
            observerRef.current = new ResizeObserver(function (entries) {
                entries.forEach(function (entry) {
                    var scrollheight = entry.target.scrollHeight;
                    setHeight(scrollheight);
                });
            });
        }
        if (containerRef.current) {
            observerRef.current.observe(containerRef.current);
            var scrollheight = containerRef.current.scrollHeight;
            setHeight(scrollheight);
        }
        return function () {
            var _a, _b;
            if (containerRef.current) {
                (_a = observerRef.current) === null || _a === void 0 ? void 0 : _a.unobserve(containerRef.current);
            }
            (_b = observerRef.current) === null || _b === void 0 ? void 0 : _b.disconnect();
        };
    }, [containerRef.current]);
    return (jsx("div", { className: classNames(styles.collapsible, (_b = {},
            _b[styles.hideDelayed] = !isExpanded,
            _b)), ref: containerRef, style: {
            maxHeight: isExpanded ? height : '0px',
        }, children: children }));
};

export { Collapsible };
//# sourceMappingURL=Collapsible.js.map
